module.exports = __webpack_public_path__ + "static/media/app-store.6d2255ee.png";